(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-experience"] && !Shopify.designMode) return;
  try {
    
function initKitchenStories(scope) {
  const stories = scope.matches && scope.matches('[data-kitchen-story]') ? [scope] : Array.from(scope.querySelectorAll('[data-kitchen-story]'));
  stories.forEach(story => {
    if (story.dataset.initialized) return;
    story.dataset.initialized = 'true';
    const stage = story.querySelector('.story-stage');
    const chapters = Array.from(story.querySelectorAll('[data-chapter]'));
    const counter = story.querySelector('[data-stage-counter]');
    const layers = Array.from(story.querySelectorAll('[data-layer]'));
    const dots = Array.from(story.querySelectorAll('[data-step]'));
    let active = 1;
    let scheduled = false;
    function setStage(next) {
      if (!stage) return;
      active = next;
      stage.dataset.stage = String(next);
      if (counter) counter.textContent = String(next).padStart(2, '0');
      layers.forEach(layer => layer.classList.toggle('is-active', Number(layer.dataset.layer) <= next));
      chapters.forEach(chapter => chapter.classList.toggle('is-current', Number(chapter.dataset.chapter) === next));
      dots.forEach(dot => {
        const current = Number(dot.dataset.step) === next;
        dot.classList.toggle('is-current', current);
        if (current) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
      });
    }
    function update() {
      scheduled = false;
      if (!story.isConnected) { window.removeEventListener('scroll', requestUpdate); return; }
      const trigger = window.innerHeight * (window.innerWidth < 901 ? 0.65 : 0.52);
      let next = 1;
      chapters.forEach(chapter => { if (chapter.getBoundingClientRect().top <= trigger) next = Number(chapter.dataset.chapter); });
      if (next !== active) setStage(next);
    }
    function requestUpdate() { if (!scheduled) { scheduled = true; window.requestAnimationFrame(update); } }
    setStage(1);
    window.addEventListener('scroll', requestUpdate, {passive: true});
    window.addEventListener('resize', requestUpdate, {passive: true});
    requestUpdate();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initKitchenStories(document));
else initKitchenStories(document);
document.addEventListener('shopify:section:load', event => initKitchenStories(event.target));
document.addEventListener('click', event => {
  const link = event.target.closest('.mobile-menu a');
  if (link) link.closest('details').removeAttribute('open');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('change',function(event){var select=event.target.closest('select[data-price-target]');if(!select)return;var option=select.options[select.selectedIndex];var price=document.getElementById(select.dataset.priceTarget);if(price)price.textContent=option.dataset.price;var button=document.getElementById(select.dataset.buttonTarget);if(button){button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.sold:button.dataset.add;}});

  } catch(e) { console.error(e); }
})();
})();
